/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsClearOrgPrice } from "../../funcs/llmModelsClearOrgPrice.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ClearOrgPriceRequest$inboundSchema,
};

export const tool$llmModelsClearOrgPrice: ToolDefinition<typeof args> = {
  name: "llm-models-clear-org-price",
  description: `Clear an org price override

Closes a per-org price. Only active cluster lineage can then fall back to the cluster default.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmModelsClearOrgPrice(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
